import { ArticleType } from "@wix/answers-api";
import { ArticleSearchResultItem, NormalizedResource, ExternalResourceType } from "../../../types";
import { stripHTML } from "../../../utils/text";


export type ArticleSourceType = ArticleType | ExternalResourceType;

export type SearchResultItem = {
  id?: string;
  title: string;
  description: string;
  url: string;
  uri?: string;
  type: ArticleSourceType;
};

export const normalizedResourceToSearchResultItem = (resource: NormalizedResource): SearchResultItem => ({
  title: resource.title,
  description: stripHTML(resource.description),
  url: resource.url,
  type: resource.source
});

export const articleSearchResultToSearchResultItem = (article: ArticleSearchResultItem): SearchResultItem => ({
  id: article.id,
  title: article.title,
  description: article.description,
  url: article.url,
  uri: article.uri,
  type: article.type
});
